import { css, keyframes, useTheme } from '@emotion/react';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
}

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export function Skeleton({ width = '100%', height = '1rem', borderRadius = '4px' }: SkeletonProps) {
  const theme = useTheme();

  return (
    <div
      aria-hidden="true"
      data-testid="skeleton"
      css={css`
        width: ${width};
        height: ${height};
        border-radius: ${borderRadius};
        background: linear-gradient(
          90deg,
          ${theme.colors.surface} 25%,
          ${theme.colors.border}66 50%,
          ${theme.colors.surface} 75%
        );
        background-size: 200% 100%;
        animation: ${shimmer} 1.5s infinite;
      `}
    />
  );
}
